import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Clock, AlertCircle, CheckCheck,
  XCircle, MapPin, Calendar, User, Upload, Play,
  Image as ImgIcon, ShieldAlert, Star,
  MessageSquare, Send, Headphones,
  DollarSign, Eye, Loader2
} from 'lucide-react';
import AppContext from '../../../../../context/AppContext';
import { statusStyle, statusLabels } from '../../../../../components/serviceprovider/workerdashboard/workerbidjobs/bidjobsconstants/BidJobsConstants';
import OtherBidsModal from '../otherbidsmodal/OtherBidsModals';
import Stars from '../../workerbidjobs/stars/Stars';
import BidForm from '../../workerbidjobs/bidform/BidForm';

const BidJobCard = ({
  b,
  i,
  jobReviews,
  reviews,
  actionLoading,
isActionLoading,
  replies,
  setReplies,
  setLightbox,
  setProofFor,
  setDisputeFor,
  setReviewFor,
  setBidModalFor,
  handleStart,
  handleCancel,
  handleBidSubmit,
  handleReply,
  viewallavailablejobs,
  handleAcceptJob,
  currentWorkerId,
  openOtherWorkerBids,
  openDisputeChat,
   bidVisibility,
    bidVisibilityLimit,
}) => {
  const navigate = useNavigate();

  const { baseUrlForFile } = useContext(AppContext);
const canViewBids = bidVisibility === true;
// ── Loading state for buttons (NEW) ──
  const [loadingBtn, setLoadingBtn] = useState({});

 const withLoading = async (key, action) => {
  if (loadingBtn[key]) return;

  setLoadingBtn(prev => ({
    ...prev,
    [key]: true
  }));

  try {
    await action();
  } finally {
    setLoadingBtn(prev => ({
      ...prev,
      [key]: false
    }));
  }
};

  // ── Core flags ──
const jobStatus = (b.display_status || b.status || '').toLowerCase();
const isBidding = Number(b.bidding) === 1;

const isNoBidding = Number(b.bidding) === 0;


// meri assigned job hai ya nahi
const isMyAssignedJob =
  Number(b.whserviceprovider_id) === Number(currentWorkerId);
 const myBidObj = Array.isArray(b.whplacebids)
  ? b.whplacebids.find(
      bid => Number(bid.whserviceprovider_id) === Number(currentWorkerId)
    )
  : null;


const hasPlacedBid = !!myBidObj;


const myBidStatus = myBidObj?.status || null;


const isMyBidSent =
  hasPlacedBid &&
  myBidStatus !== "rejected";


const isMyBidRejected =
  hasPlacedBid &&
  myBidStatus === "rejected";


const myBidAmount = myBidObj?.bidAmount ?? null;

const myBidMessage = myBidObj?.message ?? null;





const isBidWaiting =
  isBidding &&
  hasPlacedBid &&
  b.display_status === "bid_sent";

  // Kisi aur ko already assign ho gayi → ALREADY ASSIGNED
const isAlreadyAssigned =
    b.already_assigned === true;

  // Kisi ko assign nahi hui → I can accept
const canAcceptNoBid =
    isNoBidding &&
    !isMyAssignedJob &&
    b.whserviceprovider_id == null;

const displayStatus =
  b.display_status || b.status;

  const currentStatus = (displayStatus || 'pending').toLowerCase();

  const st = statusStyle[currentStatus] || statusStyle['bid_sent'] || {
    color: '#64748b',
    bg: 'rgba(100,116,139,0.12)'
  };

  const badgeLabel = currentStatus === 'bid_sent'
    ? 'Bid Sent'
    : statusLabels[currentStatus] || currentStatus;

  const badgeColor = st.color;
  const badgeBg    = st.bg;

// console.log("STATUS DEBUG", {
//  id:b.id,
//  status:b.status,
//  display_status:b.display_status,
//  jobStatus,
//  isMyAssignedJob
// });
  return (
    <div key={b.id} className="aj-card" style={{ animationDelay: i * 0.06 + 's' }}>

      {/* ── Top row ── */}
      <div className="aj-card__top">
        <div>
          <h5 className="aj-card__title">{b.jobTitle}</h5>
          <span className="aj-type-badge aj-type-badge--bid">📋 Bid Job</span>
        </div>
        <div className="aj-card__top-right">
          <span
            className="aj-badge"
            style={{ color: badgeColor, background: badgeBg }}
          >
            {badgeLabel}
          </span>

       {isMyAssignedJob &&
  ['assigned', 'in_progress', 'awaiting_confirmation', 'completed'].includes(jobStatus) && (
    <button
      type="button"
      className="aj-chat-icon"
      title="Chat with Customer"
      onClick={() =>
        navigate(`/worker-chat/${b.whconversation?.id}`, {
          state: { description: b.description }
        })
      }
    >
      <MessageSquare size={18} />
    </button>
)}
        </div>
      </div>

      {/* ── Meta ── */}
      <div className="aj-card__meta">

        <span><MapPin size={13} /> {b.address}</span>
        <span><DollarSign size={13} /> {b.budget}</span>
        <span><Calendar size={13} /> {b.deadline}</span>
        <span><User size={13} /> {b.whcustomer?.fullName}</span>
      </div>
{/* ── Job Description ── */}
{b.description && (
  <div className="aj-card__description">
    <h6>📝 Job Description</h6>
    <p>{b.description}</p>
  </div>
)}

      {/* ── Bid amount row ── */}
      {myBidAmount && (
        <div className="aj-card__bid-row">
          <span className="aj-card__bid-label">Your Bid:</span>
          <span className="aj-card__bid-val">$ {myBidAmount}</span>
          {myBidMessage && <span className="aj-card__msg">"{myBidMessage}"</span>}
        </div>
      )}

      {/* ── Customer media ── */}
      <div className="aj-media-thumbs">
        {b.whcustomerjobmedias?.map((m, mi) => (
          <button
            key={mi}
            className="aj-media-thumb"
            disabled={loadingBtn[`media-${b.id}-${mi}`]}
            onClick={() =>
              withLoading(`media-${b.id}-${mi}`, () =>
                setLightbox({
                  ...m,
                  type: m.file?.toLowerCase().match(/\.(mp4|mov|webm)$/) ? 'video' : 'image'
                })
              )
            }
          >
            {loadingBtn[`media-${b.id}-${mi}`] ? (
              <Loader2 size={14} className="aj-spin" />
            ) : m.file?.toLowerCase().match(/\.(mp4|mov)$/) ? (
              <>
                <video src={`${baseUrlForFile}/${m.file}`} className="aj-media-thumb__img" />
                <div className="aj-media-thumb__play"><Play size={14} /></div>
              </>
            ) : (
              <img src={`${baseUrlForFile}/${m.file}`} className="aj-media-thumb__img" />
            )}
          </button>
        ))}
      </div>

      {/* ── Proof media ── */}
      {b.proofMedia && b.proofMedia.length > 0 && (
        <div className="aj-media-row">
          <span className="aj-media-label" style={{ color: '#10b981' }}>
            <ImgIcon size={13} /> My Proof:
          </span>
          <div className="aj-media-thumbs">
            {b.proofMedia.map((m, mi) => (
              <button
                key={mi}
                className="aj-media-thumb"
                disabled={loadingBtn[`proofmedia-${b.id}-${mi}`]}
                onClick={() =>
                  withLoading(`proofmedia-${b.id}-${mi}`, () =>
                    setLightbox({
                      ...m,
                      type: m.file?.toLowerCase().match(/\.(mp4|mov|webm)$/) ? 'video' : 'image'
                    })
                  )
                }
              >
                {loadingBtn[`proofmedia-${b.id}-${mi}`] ? (
                  <Loader2 size={14} className="aj-spin" />
                ) : m.type === 'video' ? (
                  <video src={`${baseUrlForFile}/storage/${m.file}`} className="aj-media-thumb__img" muted />
                ) : (
                  <img src={`${baseUrlForFile}/${m.file}`} className="aj-media-thumb__img" />
                )}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* ── Review ── */}
    {b.status === "completed" && b.whreviews && (
        <div className="aj-review">
          <div className="aj-review__header">
            <User size={14} />
            <span>{b.whcustomer?.fullName}</span>
            <Stars rating={b.whreviews.rating} />
          </div>
          <p className="aj-review__text">{b.whreviews.review}</p>
          {b.whreviews.workerreply ? (
            <div className="aj-review__reply">
              <MessageSquare size={13} />
              <span>Your reply:</span> {b.whreviews.workerreply}
            </div>
          ) : (
            <div className="aj-review__reply-form">
              <input
                type="text"
                placeholder="Write a reply..."
                value={replies[b.whreviews.id] || ''}
                onChange={e =>
                  setReplies(r => ({ ...r, [b.whreviews.id]: e.target.value }))
                }
                className="aj-review__reply-input"
                disabled={loadingBtn[`reply-${b.whreviews.id}`]}
              />
              <button
                className="aj-review__reply-btn"
                disabled={loadingBtn[`reply-${b.whreviews.id}`]}
                onClick={() =>
                  withLoading(`reply-${b.whreviews.id}`, () =>
                    handleReply(b.whreviews.id)
                  )
                }
              >
                {loadingBtn[`reply-${b.whreviews.id}`]
                  ? <Loader2 size={14} className="aj-spin" />
                  : <Send size={14} />}
              </button>
            </div>
          )}
        </div>
      )}

      {/* ══════════════════════════════
           ACTIONS
      ══════════════════════════════ */}
      <div className="aj-card__actions">

        {/* ─────────────────────────────
            BIDDING JOBS
        ───────────────────────────── */}

        {/* Place Bid — sirf tab jab bid nahi ki aur job open/pending hai */}
{isBidding &&
!isMyAssignedJob &&
!hasPlacedBid &&
b.display_status === "pending" &&
b.whserviceprovider_id == null && (
<>
<button
 className="aj-btn aj-btn--progress"
 disabled={loadingBtn[`placebid-${b.id}`]}
 onClick={() =>
   withLoading(`placebid-${b.id}`, () => setBidModalFor(b.id))
 }
>
 {loadingBtn[`placebid-${b.id}`]
   ? <Loader2 size={14} className="aj-spin" />
   : <Send size={14}/>} Place Bid
</button>


<button
  className="aj-btn aj-btn--other-bids"
  disabled={loadingBtn[`viewbids-${b.id}`]}
  onClick={() => {

    if (!canViewBids) {
      navigate("/workersubscription");
      return;
    }

    withLoading(
      `viewbids-${b.id}`,
      () => openOtherWorkerBids(b)
    );

  }}
>
  {loadingBtn[`viewbids-${b.id}`] ? (
    <>
      <Loader2 size={14} className="aj-spin" />
      View Bids
    </>
  ) : (
    <>
      <Eye size={14} />
      View Bids
    </>
  )}
</button>

</>
)}
{isBidding && hasPlacedBid && !isMyAssignedJob && (

  isMyBidRejected ? (

    <div className="aj-card__rejected">
      ❌ Your bid was rejected — job assigned to another worker
    </div>

  ) : (

    <>

      <div className="aj-card__bid-success">
        ✅ Your bid submitted successfully
      </div>

      <div className="aj-card__demo-note">
        ⏳ Waiting for customer response
      </div>

    </>

  )

)}

        {/* ─────────────────────────────
            NO-BIDDING JOBS
        ───────────────────────────── */}

        {/* Accept Job — kisi ne nahi li abhi tak */}
        {canAcceptNoBid && (
          <button
            className="aj-btn aj-btn--progress"
            disabled={loadingBtn[`acceptjob-${b.id}`]}
            onClick={() =>
              withLoading(`acceptjob-${b.id}`, () => handleAcceptJob(b.id))
            }
          >
            {loadingBtn[`acceptjob-${b.id}`]
              ? <Loader2 size={14} className="aj-spin" />
              : <CheckCheck size={14} />} Accept Job
          </button>
        )}

        {/* Already Assigned — kisi aur worker ne le li */}
        {isAlreadyAssigned && (
          <div className="aj-card__demo-note">
            ⚠️ Job already assigned to another worker
          </div>
        )}

        {/* ─────────────────────────────
            MUJHE JOB MILI — assigned
        ───────────────────────────── */}
{ isMyAssignedJob && jobStatus === 'assigned' && (
            <div className="aj-card__actions-row">
            <div className="aj-card__actions-left">
              <button
                className="aj-btn aj-btn--progress"
                disabled={loadingBtn[`startjob-${b.id}`]}
                onClick={() =>
                  withLoading(`startjob-${b.id}`, () => handleStart(b.id))
                }
              >
                {loadingBtn[`startjob-${b.id}`]
                  ? <Loader2 size={14} className="aj-spin" />
                  : <AlertCircle size={14} />} Start Job
              </button>
              {/* <button
                className="aj-btn aj-btn--reject"
                onClick={() => handleCancel(b.id)}
              >
                <XCircle size={14} /> Cancel
              </button> */}
            </div>
          </div>
        )}

        {/* in_progress */}
{isMyAssignedJob && jobStatus === 'in_progress' && (        
    <>
            <button
              className="aj-btn aj-btn--complete"
              disabled={loadingBtn[`proof-${b.id}`]}
              onClick={() =>
                withLoading(`proof-${b.id}`, () => setProofFor(b.id))
              }
            >
              {loadingBtn[`proof-${b.id}`]
                ? <Loader2 size={14} className="aj-spin" />
                : <Upload size={14} />} Upload Proof &amp; Complete
            </button>
            <button
              className="aj-btn aj-btn--dispute"
              disabled={loadingBtn[`dispute-${b.id}`]}
              onClick={() =>
                withLoading(`dispute-${b.id}`, () => setDisputeFor(b))
              }
            >
              {loadingBtn[`dispute-${b.id}`]
                ? <Loader2 size={14} className="aj-spin" />
                : <ShieldAlert size={14} />} Raise Dispute
            </button>
           {/* <button
  type="button"
  className="aj-chat-icon"
  title="Chat with Customer"
  onClick={() =>
    navigate(`/worker-chat/${b.whconversation?.id}`, {
      state: { description: b.description }
    })
  }
>
  <MessageSquare size={18} />
</button> */}
          </>
        )}

        {/* awaiting_confirmation */}
{isMyAssignedJob && jobStatus === 'awaiting_confirmation' && (
            <div className="aj-awaiting-wrap">
            <div className="aj-card__awaiting">
              ⏳ Proof submitted — Waiting for customer confirmation (auto-release in 24h)
            </div>
            {/* <button
  type="button"
  className="aj-chat-icon"
  title="Chat with Customer"
  onClick={() =>
    navigate(`/worker-chat/${b.whconversation?.id}`, {
      state: { description: b.description }
    })
  }
>
  <MessageSquare size={18} />
</button> */}
          </div>
        )}

        {/* raise_dispute */}
{isMyAssignedJob && jobStatus === 'raise_dispute' && (
            <div className="aj-dispute-row">
            <div
              className="aj-card__dispute"
              style={{ color: '#f97316', background: 'rgba(249,115,22,0.09)', flex: 1 }}
            >
              🛡️ Dispute submitted — chat with Admin to resolve.
            </div>
            <button
              className="aj-btn-dispute-chat"
              disabled={loadingBtn[`chat-${b.id}`]}
              onClick={() =>
  withLoading(`chat-${b.id}`, () =>
    openDisputeChat(b)
  )
}
            >
              {loadingBtn[`chat-${b.id}`]
                ? <Loader2 size={15} className="aj-spin" />
                : <Headphones size={15} />} Chat
            </button>
          </div>
        )}

        {/* completed */}
        {b.status === 'completed' && (
          <>
            {!jobReviews[b.id]?.worker?.rating && (
              <button
                className="aj-btn aj-btn--progress"
                disabled={loadingBtn[`review-${b.id}`]}
                onClick={() =>
                  withLoading(`review-${b.id}`, () => setReviewFor(b.id))
                }
              >
                {loadingBtn[`review-${b.id}`]
                  ? <Loader2 size={14} className="aj-spin" />
                  : <Star size={14} />} Rate &amp; Review
              </button>
            )}

            {jobReviews[b.id]?.customer?.rating && (
              <div className="aj-review-display aj-review-display--customer">
                <div className="aj-review-display__header">
                  <span className="aj-review-badge aj-review-badge--customer">Customer Review</span>
                  <div className="aj-stars">
                    {[1, 2, 3, 4, 5].map(s => (
                      <Star
                        key={s} size={13}
                        fill={s <= jobReviews[b.id].customer.rating ? '#f59e0b' : '#e5e7eb'}
                        color={s <= jobReviews[b.id].customer.rating ? '#f59e0b' : '#e5e7eb'}
                      />
                    ))}
                  </div>
                </div>
                <p className="aj-review-display__text">{jobReviews[b.id].customer.review}</p>
              </div>
            )}

            {jobReviews[b.id]?.worker?.rating && (
              <div className="aj-review-display aj-review-display--worker">
                <div className="aj-review-display__header">
                  <span className="aj-review-badge aj-review-badge--worker">Your Review</span>
                  <div className="aj-stars">
                    {[1, 2, 3, 4, 5].map(s => (
                      <Star
                        key={s} size={13}
                        fill={s <= jobReviews[b.id].worker.rating ? '#f59e0b' : '#e5e7eb'}
                        color={s <= jobReviews[b.id].worker.rating ? '#f59e0b' : '#e5e7eb'}
                      />
                    ))}
                  </div>
                </div>
                <p className="aj-review-display__text">{jobReviews[b.id].worker.review}</p>
              </div>
            )}
          </>
        )}

        {/* ─────────────────────────────
            STATIC STATUS MESSAGES
        ───────────────────────────── */}
        {/* {b.display_status === 'cancelled'     && <div className="aj-card__rejected">❌ Bid was not accepted or job cancelled</div>} */}
        {b.display_status === 'refunded'       && <div className="aj-card__rejected">💸 Refunded to customer</div>}
        {b.display_status === 'dispute_frozen' && <div className="aj-card__dispute">🔒 Under admin review — all actions paused</div>}
        {b.display_status === 'admin_review'   && <div className="aj-card__dispute">⚠️ Escalated for manual decision</div>}

      </div>


 
    </div>
  );
};

export default BidJobCard;